module.exports = __webpack_public_path__ + "static/floating-action-button-one-dont-3e502fba7d9ec71f4ab508071b77dbaf.png";